export default __webpack_public_path__ + "static/media/1024.39f65c80.png";